import api from './api'
import { MotivoPerda } from '@/types/scoreComercial'

const BASE_URL = '/api/v1/oportunidades/motivos-perda'

/**
 * Catálogo de motivos de perda (decisão 8.6, V47) — dado cadastrado pelo ADMIN, nunca
 * enum no frontend. `GET` (CONSULTOR+) devolve só os ativos e selecionáveis; os
 * automáticos de reprovação (`REPROVACAO_*`) o servidor preenche sozinho.
 *
 * O backend de oportunidades NÃO embrulha respostas em ApiResponse: o interceptor de
 * `api` já entrega o body.
 */
export const motivosPerdaService = {
  /** Motivos selecionáveis, ordenados por `ordem` (a ordem é dado do catálogo). */
  listar: async (): Promise<MotivoPerda[]> => {
    const lista = (await api.get<MotivoPerda[]>(BASE_URL)) as unknown as MotivoPerda[]
    return [...(lista ?? [])].sort((a, b) => a.ordem - b.ordem)
  },
}
